import * as Radix from '@radix-ui/react-dropdown-menu';
import { Icon } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import filterStyles from '~/components/filter/Filter.module.scss';

interface FilterResetButtonProps {
  handleReset: (e: Event) => void;
}

export const FilterResetButton = ({ handleReset }: FilterResetButtonProps) => {
  const { t } = useTranslation(['common']);
  return (
    <Radix.Item className={filterStyles.resetItem} onSelect={handleReset}>
      <p
        className={filterStyles.resetButton}
        data-reset-button
        data-testid="reset-label"
      >
        <span className={filterStyles.resetIconWrapper}>
          <Icon
            iconName="Reset"
            size={16}
            fillColor="var(--icon-primary)"
            className={filterStyles.resetIcon}
          />
        </span>
        <span className={filterStyles.resetButtonLabel}>
          {t('common:filters.reset')}
        </span>
      </p>
    </Radix.Item>
  );
};
